import { cloneElement } from 'react';

import styled from 'styled-components';

import {
  CARD_PADDING,
  CARD_RADIUS,
  CONTENT_MAX_WIDTH,
  FANCY_SHADOW,
  SHADOW_ICON_COLOR,
} from '../styles/constants';

export default function EmptyStateCard({ icon, heading, sub, children }) {
  return (
    <Wrapper>
      <Container>
        <IconCard>
          <MainIcon>{cloneElement(icon, { size: 80 })}</MainIcon>
          <ShadowIcon>{cloneElement(icon, { size: 240 })}</ShadowIcon>
        </IconCard>
        <TextContainer>
          <EmptyStateHeading>{heading}</EmptyStateHeading>
          <SubHeading>{sub}</SubHeading>
          {children}
        </TextContainer>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  flex-grow: 1;
  background-color: ${(p) => p.theme.white};
  padding: 56px 24px;

  @media (max-width: 768px) {
    padding: 40px 24px;
  }
`;

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 40px;
  width: 100%;
  max-width: ${CONTENT_MAX_WIDTH};
  margin: 0 auto;
  padding: 40px;
  box-sizing: border-box;
  background-color: ${(p) => p.theme.formBackgroundColor};
  border-radius: 16px;

  @media (max-width: 600px) {
    flex-direction: column;
    text-align: center;
    gap: 24px;
    padding: ${CARD_PADDING};
  }
`;

const IconCard = styled.div`
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 9.5rem;
  height: 9.5rem;
  background-color: ${(p) => p.theme.white};
  border-radius: ${CARD_RADIUS};
  box-shadow: ${FANCY_SHADOW};
  overflow: hidden;
`;

const MainIcon = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  color: ${(p) => p.theme.headingColor};
`;

const ShadowIcon = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  display: flex;
  color: ${SHADOW_ICON_COLOR};
`;

const TextContainer = styled.div`
  display: flex;
  flex: 1 1 240px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  max-width: 424px;

  @media (max-width: 600px) {
    flex: 0 1 auto;
  }
`;

const EmptyStateHeading = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${(p) => p.theme.headingColor};
`;

const SubHeading = styled.div`
  font-size: 14px;
  color: ${(p) => p.theme.textColor};
`;
